import EVENTS from '../../../../constants/xray-ui_events.constants';

export class InstanceFormController {
    constructor($q, $scope, $state, $stateParams, $timeout, BinMgrDao, XRayUIModelSaver, JFrogGridFactory, TOOLTIPS,
                JFrogEventBus, JFrogModal, JFrogNotifications, $rootScope, XRayUIState, XRayUtils, $document) {
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.xrayUtils = XRayUtils;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.XRayUIState = XRayUIState;
        this.binMgrDao = BinMgrDao;
        this.jfrogGridFactory = JFrogGridFactory;
        this.JFrogEventBus = JFrogEventBus;
        this.JFrogNotifications = JFrogNotifications;
        this.$q = $q;
        this.modal = JFrogModal;
        this.artMode = 'onPremise';
        this.TOOLTIP = TOOLTIPS.admin.instances;
        this.$document = $document
        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;
        if (this.XRayUIState.getState('isSaas')) {
            $scope.$parent.Settings.cancelButtonText = 'Back';
        }
        this.initKonami()
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['instanceData']);
        this.modelSaver.onStateChangeCancel = () => {
            $scope.$parent.Settings.syncTabsWithState();
        };

        this.$timeout(() => {
            if (this.$state.current.name == "settings.instances.edit" || this.$state.current.name == "settings.instances.new") {

                if (this.$stateParams.instanceID) {
                    this.mode = 'edit';
                    this.title = 'Edit Instance';
                    $scope.$parent.Settings.saveButtonText = 'Save';
                    this.getInstanceData();
                }
                else {
                    this.mode = 'new';
                    this.setPlaceHolderText();
                    this.title = 'New Instance';
                    $scope.$parent.Settings.saveButtonText = 'Create';
                }
                this._createGrid();

                this.currentTab = 'repos';
                this.tabs = [{name: 'repos'}, {name: 'builds'}];
                this.baseTabsDict = {repos: 'Repositories', builds: 'Builds'};
                this.tabsDict = _.cloneDeep(this.baseTabsDict);
            }

        });

    }

    setPlaceHolderText() {
        if (this.artMode == 'onPremise') {
            this.currentArtPH = `http://<SERVER>:<PORT>/artifactory`;
        } else {
            this.currentArtPH = `<SERVER NAME>`;
        }

    }

    _createGrid() {
        this.repositoriesGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setButtons(this._getActions())
            .setColumns(this._getColumns())
            .setRowsPerPage(10)

        this.$timeout(() => {
            if (this.$scope.$root && !this.$scope.$root.licenseInvalid) {
                this.repositoriesGridOptions.setBatchActions(this._getBatchActions());
            }
        })

        this.buildsGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getBuildsColumns())
            .setRowsPerPage(10)

    }

    getInstanceData() {
        this.binMgrDao.get().$promise.then((instances) => {
            this.instanceData = _.find(instances, {binMgrId: this.$stateParams.instanceID});

            this.modelSaver.save();
            this.title = 'Edit Instance "' + this.instanceData.binMgrId + '"';
            this.indexedBuilds = this.instanceData.indexed_builds;

            if (this.indexedBuilds) {
                this.setTabCounter(this.indexedBuilds.length, 'builds');
            }

            this.buildsGridOptions.setGridData(this.indexedBuilds);
            this.getRepositories();
            this.getBuilds();
        })
    }

    getRepositories() {
        this.binMgrDao.getRepositories({}, {binMgrId: this.instanceData.binMgrId}).$promise.then((data) => {

            this.noRepos = !data.data.repositories || !data.data.repositories.length;
            this.repositoriesGridOptions.setGridData(data.data.repositories);
            this.calculateAllRepos(data.data.repositories);
            if (data.data.repositories) {
                this.setTabCounter(data.data.repositories.length);
            }

        }, (data) => {
            this.JFrogNotifications.create({error: `<span id="to-be-compiled">The instance is not available </span>`},
                true);

        });
    }

    getBuilds() {
        let defer = this.$q.defer();

        this.binMgrDao.getBuilds({$no_spinner: true}, {binMgrId: this.instanceData.binMgrId}).$promise.then(
            (response) => {
                let gridData = _.cloneDeep(this.indexedBuilds);

                this.allBuilds = _.map(response.data.builds, (n) => {
                    return {name: n};
                });

                this.availableBuildsForIndex = _.filter(this.allBuilds, (n) => {
                    return _.find(this.indexedBuilds, {name: n.name}) === undefined;
                });

                this.buildsGridOptions.setGridData(gridData);
                if (this.indexedBuilds) {
                    this.setTabCounter(this.indexedBuilds.length, 'builds');
                } else {
                    this.setTabCounter(0, 'builds');
                }
                this.modelSaver.save();
                if (this.currentTab == 'builds') {
                    this.buildsGridOptions.resetPagination();
                    this.buildsGridOptions.refreshColumns();
                }
                defer.resolve(true);

            });

        return defer.promise;
    }

    calculateAllRepos(repos) {
        if (!this.$rootScope.licenseInvalid) {

            _.each(repos, (val, key) => {

                this.getRepoStatus(val);

            });

        }
    }

    getRepoStatus(row) {
        row.statusPending = true;
        row.gotStats = false;
        this.binMgrDao.getRepositoriesStatus({$no_spinner: true}, {
            binMgrId: this.instanceData.binMgrId,
            repo_key: (row.type === 'remote' ? row.name + '-cache' : row.name)
        }).$promise.then((data) => {
            if (data.completed !== undefined && data.potential !== undefined) {
                row.stats = data;
                row.stats.percent = Math.floor(100 * row.stats.completed / row.stats.potential);
            }
            else {
                row.stats = {error: 'Repository not supported'};
            }
            row.gotStats = true;
        });
    }

    checkIfConfigured(payload) {
        let defer = this.$q.defer();
        this.binMgrDao.checkConfiguration({}, payload).$promise.then((res) => {

            if (res.configured) {

                this.modal.confirm(
                    'This Artifactory instance is already connected to another instance of Xray. Are you sure you want to connect and override that connection?')
                    .then(() => {
                        defer.resolve(true);
                    }, () => {
                        defer.resolve(false);
                    });
            } else {

                defer.resolve(true);
            }
        });
        return defer.promise;
    }


    save() {
        if (!this.canSave()) {
            return;
        }
        let originalSaveText = _.cloneDeep(this.$scope.$parent.Settings.saveButtonText)
        this.$scope.$parent.Settings.saveButtonText = "Saving...";
        this.saveInProgress = true;
        let payload = _.cloneDeep(this.instanceData);
        this.checkIfConfigured(payload).then((response) => {

            if (response) {

                payload.binMgrUrl = this.removeSlashesFromTail(payload.binMgrUrl);

                if (this.artMode === 'aol') {
                    payload.binMgrUrl = `https://${payload.binMgrUrl}.jfrog.io/${payload.binMgrUrl}`;
                }

                let promise;
                if (this.mode === 'new') {
                    promise = this.binMgrDao.createConnection(payload).$promise;
                }
                else {
                    promise = this.binMgrDao.updateConnection(payload).$promise;
                }
                promise.then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        this.JFrogEventBus.dispatch(EVENTS.FOOTER_REFRESH);
                        this.modelSaver.save();

                        if (this.mode === 'new') {
                            this.getBuilds().then(() => {
                                if (this.availableBuildsForIndex.length != 0) {
                                    this.configureIndexedRepos(true);
                                } else {
                                    this.configureIndexedRepos(false);
                                }


                            });

                        }
                        else {

                            this.$state.go('settings.instances');


                        }
                    }
                    this.saveInProgress = false;
                    this.$scope.$parent.Settings.saveButtonText = originalSaveText;
                });
            }
            else {
            }
        });

    }

    removeSlashesFromTail(str) {
        while (str.endsWith('/')) {
            str = str.substr(0, str.length - 1);
        }
        return str;
    }

    cancel() {
        this.$state.go('settings.instances');
    }

    indexSelected() {
        let selectedRows = this.repositoriesGridOptions.api.selection.getSelectedRows();
        console.log('selected rows are', selectedRows);
        let rowsToIndex = _.cloneDeep(selectedRows);
        _.map(rowsToIndex, (o) => {
            if (o.type == 'remote') {
                o.name = o.name + '-cache';
            }
        });
        let repos = _.map(rowsToIndex, 'name');
        this.binMgrDao.indexRepository({binMgrId: this.instanceData.binMgrId}, repos).$promise.then((res) => {
        })

    }

    indexRepository(row) {
        let payload = [row.type === 'remote' ? row.name + '-cache' : row.name];

        this.modal.confirm(
            `You are about to index ${row.stats.potential - row.stats.completed} previously existing artifacts in this repository. Continue?`)
            .then(() => {
                this.binMgrDao.indexRepository({binMgrId: this.instanceData.binMgrId}, payload).$promise.then((res) => {
                })
            });

    }


    _getColumns() {
        return [
            {
                name: 'Repository Key',
                displayName: 'Repository Key',
                field: 'name',
                width: '40%'
            },
            {
                name: 'Type',
                displayName: 'Type',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.type | capitalizeFirst}}</div>`,
                field: 'type',
                width: '10%'
            },
            {
                name: 'Package Type',
                displayName: 'Package Type',
                field: 'pkgType',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.pkgType | capitalizeFirst}}</div>`,
                width: '15%'
            },
            {
                name: 'Index Status',
                displayName: 'Index Status',
                field: 'dummy',
                enableSorting: false,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.gotStats && !row.entity.stats.error"><div jf-tooltip-on-overflow class="stats-content"><span>{{row.entity.stats.completed}} / {{row.entity.stats.potential}}</span> <span ng-if="row.entity.stats.potential">({{row.entity.stats.percent}}%)</span></div></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="row.entity.gotStats && row.entity.stats.error"><div jf-tooltip-on-overflow class="stats-content"><span class="error" style="color:red">{{row.entity.stats.error}}</span> </div></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="!row.entity.gotStats && row.entity.statusPending"><div class="icon-hourglass grid-hourglass"></div></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="!row.entity.gotStats && !row.entity.statusPending"></div>',
                width: '35%'
            }
        ]
    }

    _getBuildsColumns() {
        return [
            {
                name: 'Build Name',
                displayName: 'Build Name',
                field: 'name',
                width: '100%'
            }
        ]
    }

    checkInstanceName(retypeVal) {
        if (typeof retypeVal !== 'undefined') {

            if (retypeVal.toLowerCase().indexOf('::') > -1) {
                return false;
            } else {
                return true;
            }
        }
    }

    _getActions() {
        return [
            {
                icon: 'icon refresh icon-refresh',
                tooltip: 'Refresh',
                callback: (row) => this.getRepoStatus(row),
                visibleWhen: (row) => {

                    if (!this.$rootScope.licenseInvalid) {
                        if (row.stats) {
                            return !row.stats.error;
                        } else {
                            return true;
                        }

                    } else {
                        return false;
                    }

                }
            },
            {
                icon: 'icon icon-re-index',
                tooltip: 'Index Existing',
                callback: (row) => this.indexRepository(row),
                visibleWhen: (row) => {
                    if (!this.$rootScope.licenseInvalid) {
                        if (row.stats) {
                            return !row.stats.error;
                        } else {
                            return true;
                        }

                    } else {
                        return false;
                    }
                }
            }
        ];
    }

    _getBatchActions() {
        return [
            {
                icon: 'icon-re-index',
                name: 'Index Existing',
                callback: () => this.indexSelected()
            }
        ]
    }

    canSave() {

        if (this.saveInProgress || this.XRayUIState.getState('isSaas')) {
            return false;
        }
        if (this.instanceForm) {
            return this.instanceForm.$valid;
        }
    }


    configureIndexedRepos(exitState) {
        this.binMgrDao.getAllRepositories({}, {binMgrId: this.instanceData.binMgrId}).$promise.then((data) => {
            let modalScope = this.$scope.$new();
            let modalInstance;
            modalScope.modalTitle = 'Select Repositories For Index';
            modalScope.objectName = 'Repositories';
            modalScope.leftTitle = 'Available Repositories';
            modalScope.rightTitle = 'Selected Repositories';
            modalScope.availableRepos = data.non_indexed || [];
            modalScope.indexedRepos = data.indexed || [];

            modalScope.save = (indexedRepos) => {
                modalInstance.close();

                let addList = _.map(indexedRepos, (obj) => _.pick(obj, ['name', 'type']));

                let payload = {
                    binMgrId: this.instanceData.binMgrId,
                    repos: addList
                };

                this.binMgrDao.setIndexedRepos({}, payload).$promise.then((result) => {
                    if (exitState) {
                        //this.$state.go('settings.instances');
                        this.configureIndexedBuilds(true);
                    } else {
                        this.getRepositories();
                        this.modelSaver.save();
                        if (this.mode === 'new') {
                            this.$state.go('settings.instances');
                        }

                    }
                })
            };

            modalInstance = this.modal.launchModal('add_xray_index_modal', modalScope);

            modalInstance.result.catch(() => {
                if (exitState) {
                    //this.$state.go('settings.instances');
                    this.configureIndexedBuilds(true);
                }
            })
        });
    }

    configureIndexedBuilds(exitState) {
        if (!this.allBuilds) {
            return;
        }

        let modalScope = this.$scope.$new();
        let modalInstance;
        modalScope.objectName = 'Builds';
        modalScope.leftTitle = 'Available Builds';
        modalScope.rightTitle = 'Selected Builds';
        modalScope.modalTitle = 'Select Builds For Index';
        modalScope.availableRepos = this.availableBuildsForIndex;
        modalScope.indexedRepos = this.indexedBuilds;
        modalScope.save = (indexedBuilds) => {
            modalInstance.close();

            let addList = _.map(indexedBuilds, (obj) => _.pick(obj, ['name']));

            let payload = {
                binMgrId: this.instanceData.binMgrId,
                indexed_builds: addList
            };

            this.binMgrDao.setBuildsForIndex({}, payload).$promise.then((result) => {
                if (exitState) {
                    this.modelSaver.save();
                    if (this.mode === 'new') {
                        this.$state.go('settings.instances');
                    }

                } else {

                    this.getInstanceData();
                }
            })
        };

        modalInstance = this.modal.launchModal('add_xray_index_modal', modalScope);

        modalInstance.result.catch(() => {
            if (exitState) {

                this.$state.go('settings.instances');
            }
        })

    }

    testInstance() {
        if (this.instanceData) {

            let payload = {
                binMgrId: this.instanceData.binMgrId,
                binMgrUrl: this.instanceData.binMgrUrl,
                user: this.instanceData.user,
                password: this.instanceData.password,
                proxy_enabled: this.instanceData.proxy_enabled
            }
            if (this.artMode === 'aol') {
                /*if (payload.binMgrUrl.indexOf('http://') > -1 || payload.binMgrUrl.indexOf('https://') > -1) {
                    let errMsg = {'error': 'Artifactory online mode - Please use server name only '};

                    this.showWizardNotification(errMsg);
                    return;
                }*/
                payload.binMgrUrl = `https://${payload.binMgrUrl}.jfrog.io/${payload.binMgrUrl}`;
            }
            this.binMgrDao.testConnection({}, payload).$promise.then((data) => {
                this.JFrogNotifications.create(data);
            }, () => this.JFrogNotifications.create(data));
        }

    }

    checkLocalHost(retypeVal) {

        if (this.artMode == 'aol' && retypeVal && retypeVal.indexOf('localhost') < 0) {
            return true;
        } else {

            if (typeof retypeVal !== 'undefined') {

                if (retypeVal.toLowerCase().indexOf('localhost') > -1 || retypeVal.toLowerCase().indexOf(
                    '127.0.0.1') > -1) {

                    return false;
                } else {

                    return true;
                }
            }
        }

        //return !retypeVal || (retypeVal && this.input.password === retypeVal);
    }


    onChangeTab(tab) {

        let oldTab = this.currentTab;
        this.currentTab = tab.name;
        if (this.buildsGridOptions.api && this.currentTab == 'builds') {
            this.buildsGridOptions.resetPagination();
            this.buildsGridOptions.refreshColumns();
        }
    }


    setTabCounter(length, type = '') {

        if (type == '') {
            this.tabsDict.repos = this.baseTabsDict['repos'] + ` (${length})`;
        }
        if (type == 'builds') {
            this.tabsDict.builds = this.baseTabsDict['builds'] + ` (${length})`;
        }

    }

    /* ====  KONAMI SECTION ==== */

    initKonami() {
        this.keys = "";
        this.code = "38384040373937396665";
        this.timer = null;
        let self = this;
        this.$document.off('keyup', this.keyup.bind(self)).on('keyup', this.keyup.bind(self));
        //console.log("Listening!")
    }

    cleanup() {
        this.$timeout(() => {
            clearTimeout(this.timer)
        });
    }

    konamiSucceed() {

        console.log("Code is Valid!!")
        this.$timeout(() => {
            this.canSave = () => true;
        });

    }

    keyup(event) {
        // console.log('Event is',event)
        let self = this;
        clearTimeout(this.timer);
        this.keys += event.which.toString();
        //console.log("This keys:", this.keys)
        this.timer = setTimeout(this.cleanup.bind(self), 1000);
        if (this.keys === this.code) this.konamiSucceed();
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/instances/instance_form.controller.js